import { styled, css } from '@mui/material/styles';

const sharedCSS = css`
    padding: 0.75rem;
    margin: 0 0.75rem;
    border: none;
`;

export const StyledFieldset = styled('fieldset')`
    display: flex;
    flex-direction: column;

    ${sharedCSS}
`;

export const StyledFieldsetAdvanced = styled('fieldset')`
    display: grid;
    grid-template-columns: 1fr 1fr;

    ${sharedCSS}

    grid-row-gap: 1rem;
`;

export const StyledInputContainer = styled('div')`
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
`;

export const StyledLoadingFieldsetAdvanced = styled('fieldset')`
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr;
    grid-column-gap: 2rem;

    padding: 0.75rem;
    margin: 0 0.75rem;
    border: none;

    border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;
